import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { api } from "../../../config/api";
import Loader from "../../shared/loader/loader";
import DashboardLayout from "../../layout";
import Details from "./Details";
import Header from "../../header/Header";
import Chat from "./Chat";
import { useMyContext } from "../../../context/MyContext";

const TicketDetails = () => {
  const { id } = useParams();
  const { token } = useMyContext();

  const { data, isLoading } = useQuery(
    ["ticket", id],
    async () => {
      const res = await api.get(`/tickets/${id}`, {
        headers: {
          Authorization: `Bearer ${token}` // Include the token in the request headers
        }
      });
      return res.data;
    },
    {
      enabled: !!id && !!token, // Only run the query if we have both id and token
      refetchOnWindowFocus: false,
    }
  );

  if (isLoading) {
    return <Loader />;
  }

  return (
    <DashboardLayout>
      <Header title={`Ticket #${data?.ticketNumber}`} />
      {/* <div className="pl-10 pr-5 py-3 bg-gradient-to-r from-indigo-50 to-indigo-100 shadow-md rounded-lg">
        <p className="text-lg font-semibold text-indigo-800">Quote Number: {data?.quoteNumber}</p>
        <p className="text-md mt-2 text-gray-700">Description: {data?.description}</p>
      </div>
      <main className="p-5 flex flex-col space-y-4 bg-[#f5f5f5]">
        <div className="bg-white rounded-[22px] flex flex-col space-y-2">
          <div className="flex flex-col space-y-2">
            <Chat ticket={data} />
          </div>
        </div>
      </main> */}
      <div className="w-full h-full flex flex-col items-center justify-start p-4 gap-4">
        <div className="bg-white w-full rounded-lg p-5 flex flex-col items-start justify-center shadow-lg hover:shadow-xl transition-all duration-300">
          <p className="text-lg font-medium">
            {data?.orderNumber ? "Order Number" : "Quote Number"}: {" "}
            <span>{data?.orderNumber || data?.quoteNumber || "--"}</span>
          </p>
          <p className="font-light">Description: {data?.description}</p>
        </div>
        <Chat ticket={data} />
      </div>
    </DashboardLayout>
  );
};

export default TicketDetails;